const MessageBubbleIcon = ({ size = 11 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        d="M2 3.2A1.2 1.2 0 013.2 2h7.6A1.2 1.2 0 0112 3.2v5A1.2 1.2 0 0110.8 9.4H5.2L3 11.4V9.4A1.2 1.2 0 012 8.2z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MessageBubbleIcon;
